import { render, staticRenderFns } from "./LoyaltyStampSuccess.vue?vue&type=template&id=d9980e3a&scoped=true&lang=pug&"
import script from "./LoyaltyStampSuccess.vue?vue&type=script&lang=js&"
export * from "./LoyaltyStampSuccess.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyStampSuccess.vue?vue&type=style&index=0&id=d9980e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9980e3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
